import { ILanguageSelectorProps } from "./IHomePage";

const LanguageSelector = (props: ILanguageSelectorProps) => {
  const { language, setLanguage, availableLanguages } = props;
  return (
    <div className="language-selector">
      {availableLanguages.map((item) => (
        <button
          key={item.code}
          className={`${language === item.code && 'selectedLanguage'}`}
          onClick={() => setLanguage(item.code)}
        >
          {item.code.toUpperCase()}
        </button>
      ))}
    </div>
  );
};

export default LanguageSelector;
